const INFINITY = 1 / 0;

const symbolTag = '[object Symbol]';

const reAsciiWord = /[^\x20-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

const reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

const rsAstralRange = '\\ud800-\\udfff',
	rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	rsComboSymbolsRange = '\\u20d0-\\u20f0',
	rsDingbatRange = '\\u2700-\\u27bf',
	rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	rsPunctuationRange = '\\u2000-\\u206f',
	rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	rsVarRange = '\\ufe0e\\ufe0f',
	rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

let rsApos = "['\u2019]",
	rsAstral = '[' + rsAstralRange + ']',
	rsBreak = '[' + rsBreakRange + ']',
	rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	rsDigits = '\\d+',
	rsDingbat = '[' + rsDingbatRange + ']',
	rsLower = '[' + rsLowerRange + ']',
	rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	rsFitz = '\\ud83c[\\udffb-\\udfff]',
	rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	rsNonAstral = '[^' + rsAstralRange + ']',
	rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	rsUpper = '[' + rsUpperRange + ']',
	rsZWJ = '\\u200d';

const rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	reOptMod = rsModifier + '?',
	rsOptVar = '[' + rsVarRange + ']?',
	rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	rsSeq = rsOptVar + reOptMod + rsOptJoin,
	rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

const reApos = RegExp(rsApos, 'g');

const reComboMark = RegExp(rsCombo, 'g');

const reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

const reUnicodeWord = RegExp([
	rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	rsUpper + '+' + rsOptUpperContr,
	rsDigits,
	rsEmoji
].join('|'), 'g');

const reHasUnicode = RegExp(`[${rsZWJ}${rsAstralRange}${rsComboMarksRange}${rsComboSymbolsRange}${rsVarRange}]`);
// const reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

const reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

const deburredLetters = {
	'\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	'\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	'\xc7': 'C', '\xe7': 'c',
	'\xd0': 'D', '\xf0': 'd',
	'\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	'\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	'\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	'\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i',
	'\xd1': 'N', '\xf1': 'n',
	'\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	'\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	'\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	'\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	'\xdd': 'Y', '\xfd': 'y', '\xff': 'y',
	'\xc6': 'Ae', '\xe6': 'ae',
	'\xde': 'Th', '\xfe': 'th',
	'\xdf': 'ss',
	'\u0100': 'A', '\u0102': 'A', '\u0104': 'A',
	'\u0101': 'a', '\u0103': 'a', '\u0105': 'a',
	'\u0106': 'C', '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	'\u0107': 'c', '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	'\u010e': 'D', '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	'\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	'\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	'\u011c': 'G', '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	'\u011d': 'g', '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	'\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	'\u0128': 'I', '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	'\u0129': 'i', '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	'\u0134': 'J', '\u0135': 'j',
	'\u0136': 'K', '\u0137': 'k', '\u0138': 'k',
	'\u0139': 'L', '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	'\u013a': 'l', '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	'\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	'\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	'\u014c': 'O', '\u014e': 'O', '\u0150': 'O',
	'\u014d': 'o', '\u014f': 'o', '\u0151': 'o',
	'\u0154': 'R', '\u0156': 'R', '\u0158': 'R',
	'\u0155': 'r', '\u0157': 'r', '\u0159': 'r',
	'\u015a': 'S', '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	'\u015b': 's', '\u015d': 's', '\u015f': 's', '\u0161': 's',
	'\u0162': 'T', '\u0164': 'T', '\u0166': 'T',
	'\u0163': 't', '\u0165': 't', '\u0167': 't',
	'\u0168': 'U', '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	'\u0169': 'u', '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	'\u0174': 'W', '\u0175': 'w',
	'\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y',
	'\u0179': 'Z', '\u017b': 'Z', '\u017d': 'Z',
	'\u017a': 'z', '\u017c': 'z', '\u017e': 'z',
	'\u0132': 'IJ', '\u0133': 'ij',
	'\u0152': 'Oe', '\u0153': 'oe',
	'\u0149': "'n", '\u017f': 'ss'
};

const freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

const freeSelf = typeof self == 'object' && self && self.Object === Object && self;

const root = freeGlobal || freeSelf || Function('return this')();

function arrayReduce(array, iteratee, accumulator, initAccum) {
	let index = -1,
		length = array ? array.length : 0;

	if (initAccum && length) {
		accumulator = array[++index];
	}
	while (++index < length) {
		accumulator = iteratee(accumulator, array[index], index, array);
	}
	return accumulator;
}

function asciiToArray(string) {
	return string.split('');
}

function asciiWords(string) {
	return string.match(reAsciiWord) || [];
}

function basePropertyOf(object) {
	return function (key) {
		return object == null ? undefined : object[key];
	};
}

const deburrLetter = basePropertyOf(deburredLetters);

function hasUnicode(string) {
	return reHasUnicode.test(string);
}

function hasUnicodeWord(string) {
	return reHasUnicodeWord.test(string);
}

function stringToArray(string) {
	return hasUnicode(string)
		? unicodeToArray(string)
		: asciiToArray(string);
}

function unicodeToArray(string) {
	return string.match(reUnicode) || [];
}

function unicodeWords(string) {
	return string.match(reUnicodeWord) || [];
}

const objectProto = Object.prototype;

const objectToString = objectProto.toString;

const Symbol = root.Symbol;

const symbolProto = Symbol ? Symbol.prototype : undefined,
	symbolToString = symbolProto ? symbolProto.toString : undefined;

function baseSlice(array, start, end) {
	let index = -1,
		length = array.length;

	if (start < 0) {
		start = -start > length ? 0 : (length + start);
	}
	end = end > length ? length : end;
	if (end < 0) {
		end += length;
	}
	length = start > end ? 0 : ((end - start) >>> 0);
	start >>>= 0;

	const result = Array(length);
	while (++index < length) {
		result[index] = array[index + start];
	}
	return result;
}

function baseToString(value) {
	if (typeof value == 'string') {
		return value;
	}
	if (isSymbol(value)) {
		return symbolToString ? symbolToString.call(value) : '';
	}
	const result = (value + '');
	return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

function castSlice(array, start, end) {
	const length = array.length;
	end = end === undefined ? length : end;
	return (!start && end >= length) ? array : baseSlice(array, start, end);
}

function createCaseFirst(methodName) {
	return function (string) {
		string = toString(string);

		const strSymbols = hasUnicode(string)
			? stringToArray(string)
			: undefined;

		const chr = strSymbols
			? strSymbols[0]
			: string.charAt(0);

		const trailing = strSymbols
			? castSlice(strSymbols, 1).join('')
			: string.slice(1);

		return chr[methodName]() + trailing;
	};
}

function createCompounder(callback) {
	return function (string) {
		return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	};
}

function isObjectLike(value) {
	return !!value && typeof value == 'object';
}

function isSymbol(value) {
	return typeof value == 'symbol' ||
		(isObjectLike(value) && objectToString.call(value) == symbolTag);
}

function toString(value) {
	return value == null ? '' : baseToString(value);
}


function capitalize(string) {
	return upperFirst(toString(string).toLowerCase());
}

function deburr(string) {
	string = toString(string);
	return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

const upperFirst = createCaseFirst('toUpperCase');

function words(string, pattern, guard) {
	string = toString(string);
	pattern = guard ? undefined : pattern;

	if (pattern === undefined) {
		return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	}
	return string.match(pattern) || [];
}

const camelCase = createCompounder(function (result, word, index) {
	word = word.toLowerCase();
	return result + (index ? capitalize(word) : word);
});
export default camelCase;